package com.eladfinish.bible.contest.di

import com.eladfinish.bible.contest.usecase.GetRemoteConfigObjectUseCase
import com.eladfinish.bible.contest.usecase.GetRemoteConfigValueUseCase
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val useCaseModule = module {
    factoryOf(::GetRemoteConfigValueUseCase)
    factoryOf(::GetRemoteConfigObjectUseCase)
}
